var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowInterestRate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8588 7.80883L6.16915 11.5156C4.58661 12.2803 3.42891 13.7247 3.04656 15.4347L1.14538 23.7617C0.752403 25.4716 1.16663 27.2772 2.26059 28.6473L7.58175 35.3279C8.67571 36.698 10.3432 37.5053 12.0957 37.5053H20.635C22.3981 37.5053 24.055 36.7087 25.1489 35.3279L30.4701 28.6473C31.564 27.2772 31.9783 25.4716 31.5853 23.7617L29.6841 15.4347C29.2911 13.7247 28.1441 12.2803 26.5615 11.5156L18.8719 7.80883C17.2894 7.04411 15.4413 7.04411 13.8588 7.80883Z",
    fill: "#FF5200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4672 16.022C14.1761 16.022 15.5658 17.4117 15.5658 19.1206C15.5658 20.8295 14.1761 22.2192 12.4672 22.2192C10.7583 22.2192 9.36858 20.8295 9.36856 19.1206C9.36856 17.4117 10.7583 16.022 12.4672 16.022ZM12.4672 17.1421C11.3721 17.1421 10.4887 18.0256 10.4887 19.1206C10.4887 20.2157 11.3722 21.0991 12.4672 21.0991C13.5622 21.0991 14.4457 20.2156 14.4457 19.1206C14.4457 18.0256 13.5622 17.1421 12.4672 17.1421Z",
    fill: "white",
    stroke: "#FFE8DC",
    strokeWidth: 1.00392
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4211 23.2116C23.13 23.2116 24.5197 24.6014 24.5197 26.3102C24.5197 28.0191 23.1299 29.4088 21.4211 29.4089C19.7122 29.4089 18.3225 28.0191 18.3224 26.3102C18.3224 24.6013 19.7122 23.2116 21.4211 23.2116ZM21.4211 24.3317C20.3261 24.3317 19.4426 25.2152 19.4426 26.3102C19.4426 27.4052 20.3261 28.2888 21.4211 28.2888C22.5161 28.2887 23.3995 27.4052 23.3996 26.3102C23.3996 25.2152 22.5161 24.3318 21.4211 24.3317Z",
    fill: "white",
    stroke: "#FFE8DC",
    strokeWidth: 1.00392
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3417 28.5616L23.1417 16.22",
    stroke: "#FFE8DC",
    strokeWidth: 2.00783,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5607 35.4408C34.599 35.4408 35.4407 34.5991 35.4407 33.5609C35.4407 32.5226 34.599 31.6809 33.5607 31.6809C32.5225 31.6809 31.6808 32.5226 31.6808 33.5609C31.6808 34.5991 32.5225 35.4408 33.5607 35.4408Z",
    fill: "#FF5200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3881 17.3571L34.2438 5.23184L28.5069 5.30012L28.6512 17.4254L34.3881 17.3571Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2751 15.9855L31.7155 26.8634L38.895 15.8115L24.2751 15.9855Z",
    fill: "#FFCDB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2751 13.4598L31.7155 24.3377L38.895 13.2858L24.2751 13.4598Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1228 7H23.8772C23.8772 5.41459 22.5907 4.12277 21 4.12277V3.8772C22.5854 3.8772 23.8772 2.59075 23.8772 1H24.1228C24.1228 2.58541 25.4093 3.8772 27 3.8772V4.12277C25.4146 4.12277 24.1228 5.40925 24.1228 7Z",
    fill: "#FF5200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowInterestRate);
export default __webpack_public_path__ + "static/media/low_interest_rate.e6041b4cfa583124d3bab09c6169c5ac.svg";
export { ForwardRef as ReactComponent };